/**
 * The shell that renders the global nav rail publishes where the stage starts, so Kelly's full-screen dock can
 * cover the stage and leave the rail showing (ADR 0020). The dock is a fixed sibling of the shell rather than a
 * descendant, so the value has to travel through `:root` — it cannot be inherited down from the shell's own box.
 *
 * Ref-counted rather than a bare set/remove, because ADR 0020 section 3 invites APP-2407 to add callers: with two
 * shells mounted at once the first to unmount would strip the value while a rail was still on screen, sliding
 * full-screen Kelly over it. Structurally one writer rather than one by convention.
 */

import { useLayoutEffect } from "react"
import { NAV_RAIL_WIDTH, STAGE_LEFT_VAR } from "../geometry/dock-metrics"

let publisherCount = 0

/** Exported for tests: the count is module state, so a leaked or double-counted publisher is otherwise invisible. */
export function getStageLeftPublisherCount(): number {
  return publisherCount
}

export function useStageLeft(isRailVisible: boolean): void {
  useLayoutEffect(() => {
    if (!isRailVisible) return undefined
    publisherCount += 1
    document.documentElement.style.setProperty(STAGE_LEFT_VAR, NAV_RAIL_WIDTH)
    return () => {
      publisherCount -= 1
      if (publisherCount === 0) document.documentElement.style.removeProperty(STAGE_LEFT_VAR)
    }
  }, [isRailVisible])
}
